export default {
	data () {
		return {
			expanded: this.collapsed === undefined ? false : !this.collapsed,
			inTransition: false,
			offsetHeight: 0,
			refKey: 'content',
			collapsedHeight: 0,
			_transitionHandler: null
		}
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		collapsed: {
			type: Boolean,
			default: undefined
		}
	},
	mounted () {
		const collapsed = this.collapsed === undefined ? !this.expanded : this.collapsed
		const el = this.$refs[this.refKey]
		if (!el) return
		if (collapsed) {
			this.expanded = false
			el.style.height = this.collapsedHeight + 'px'
		} else {
			this.expanded = true
		}
	},
	beforeDestroy () {
		this._cleanupTransition()
	},
	methods: {
		_cleanupTransition () {
			const el = this.$refs[this.refKey]
			if (el && this._transitionHandler) {
				el.removeEventListener('transitionend', this._transitionHandler)
				this._transitionHandler = null
			}
		},

		_onTransitionEnd (callback) {
			this._cleanupTransition()
			const el = this.$refs[this.refKey]
			this._transitionHandler = (e) => {
				if (e.target !== el || e.propertyName !== 'height') return
				el.removeEventListener('transitionend', this._transitionHandler)
				this._transitionHandler = null
				callback()
			}
			el.addEventListener('transitionend', this._transitionHandler)
		},

		collapse () {
			if (!this.expanded || this.inTransition) return
			const el = this.$refs[this.refKey]
			const currentHeight = el.offsetHeight

			if (currentHeight === this.collapsedHeight) {
				this.expanded = false
				return
			}

			this._onTransitionEnd(() => {
				this.inTransition = false
			})

			el.style.height = currentHeight + 'px'
			getComputedStyle(el).height // eslint-disable-line no-unused-expressions

			requestAnimationFrame(() => {
				this.inTransition = true
				this.expanded = false
				el.style.height = this.collapsedHeight + 'px'
			})
		},

		expand () {
			if (this.expanded || this.inTransition) return
			const el = this.$refs[this.refKey]

			el.style.height = null
			const targetHeight = el.scrollHeight

			if (targetHeight === this.collapsedHeight) {
				this.expanded = true
				return
			}

			this._onTransitionEnd(() => {
				this.inTransition = false
				el.style.height = null
			})

			el.style.height = this.collapsedHeight + 'px'
			getComputedStyle(el).height // eslint-disable-line no-unused-expressions

			requestAnimationFrame(() => {
				this.inTransition = true
				this.expanded = true
				el.style.height = targetHeight + 'px'
			})
		},

		recalculateHeight () {
			if (this.expanded && !this.inTransition) {
				const el = this.$refs[this.refKey]
				if (!el) return

				const currentHeight = el.offsetHeight
				el.style.height = currentHeight + 'px'
				getComputedStyle(el).height // eslint-disable-line no-unused-expressions

				const newHeight = el.scrollHeight
				if (newHeight === currentHeight) {
					el.style.height = null
					return
				}

				this._onTransitionEnd(() => {
					this.inTransition = false
					el.style.height = null
				})

				requestAnimationFrame(() => {
					this.inTransition = true
					el.style.height = newHeight + 'px'
				})
			}
		},

		toggle () {
			if (!this.disabled) {
				this.$emit('toggle-status-change', !this.expanded)
				this.expanded ? this.collapse() : this.expand()
			}
		}
	}
}

